import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as MinusCircleIcon } from './minusCircle.svg';

export const MinusCircle = IconHOC(MinusCircleIcon);
